import React from 'react'
import cx from 'classnames'

import Grid from '../../../../components/Grid'
import Icon, { EIconId } from '../../../../components/icons'

import { TNavItem } from '../../../../types/mainNavigation'
import { appendNavParameter } from '../../../../utils/buildUrlFromSuggestion'
import trackEvent from '../../../../utils/gtm/trackEvent'
import { getEecPromoClickEventForCampaign } from '../../../../utils/gtm/eecPromoClickEvents'
import { getEecPromoImpressionEventForCampaign } from '../../../../utils/gtm/eecPromoImpressionEvents'

const NavigationBarFlyout: React.FC<TNavItem & { isActive: boolean }> = (props) => {
  const item = props.flyoutNavItem
  const hasCampaign = item.campaign?.targetUrl
  const hasBrands = item.brands.length > 0

  React.useEffect(() => {
    props.isActive &&
      item.campaign &&
      trackEvent(getEecPromoImpressionEventForCampaign(item.campaign, window.location.pathname))
  }, [props.isActive])

  return (
    <Grid.Row
      className={cx('absolute z-50 left-0 uif-top-edge bg-white text-dark -ml-48 overflow-hidden uif-shadow', {
        hidden: !props.isActive,
      })}
      style={{ width: 'calc(100% + 6rem)' }}
    >
      <Grid.Col className="flex flex-col px-48 py-32 relative" style={{ minHeight: '31.75rem' }}>
        <img loading="lazy" className="absolute top-0 right-0 h-full" src={props.flyoutNavItem.imageUrl} alt="" />
        {item.categories.length > 0 && (
          <ul className="-mt-8 relative">
            {item.categories.map((category) => (
              <li key={category.label}>
                <NavLink label={category.label} url={category.url} id={category.trackingId} />
              </li>
            ))}
          </ul>
        )}
        {item.categoryLabel && item.categoryLabelUrl && (
          <NavLink
            label={item.categoryLabel}
            url={item.categoryLabelUrl}
            id={item.categoryLabelId}
            hasArrow={true}
            className="relative mt-auto"
          />
        )}
      </Grid.Col>
      <Grid.Col className="flex flex-col px-48 py-32 relative">
        {hasBrands && (
          <>
            <p className="font-bold mb-8">Top Marken</p>
            <ul style={{ columnCount: 2 }}>
              {item.brands.map((brand) => (
                <li key={brand.label}>
                  <NavLink label={brand.label} url={brand.url} id={brand.trackingId} />
                </li>
              ))}
            </ul>
            {item.brandLabelUrl && (
              <NavLink
                label="Marken entdecken"
                id={item.brandLabelId}
                url={item.brandLabelUrl}
                hasArrow={true}
                className={cx({ 'mt-auto': !hasCampaign })}
              />
            )}
          </>
        )}
        {item.campaign?.targetUrl && ( // <- normally this would also be `hasCampaign` but unfortunately this doesn't work. maybe a bug in typescript
          <>
            <p className={cx('mb-8 font-bold', { 'mt-auto': hasBrands })}>Aktuelles Highlight</p>
            <a
              className={cx('flex flex-col justify-center px-24 bg-lightgrey-light bg-cover', item.campaign.textColor)}
              style={{
                ...(item.campaign.backgroundColor ? { backgroundColor: item.campaign.backgroundColor } : {}),
                ...(item.campaign.imageUrl ? { backgroundImage: `url(${item.campaign.imageUrl})` } : {}),
                height: '10.5rem',
              }}
              href={item.campaign.targetUrl}
              id={item.campaign.trackingId}
              onClick={() =>
                item.campaign && trackEvent(getEecPromoClickEventForCampaign(item.campaign, window.location.pathname))
              }
            >
              {item.campaign.label && (
                <span className="mb-8 font-bold text-24 leading-28 w-1/2">{item.campaign.label}</span>
              )}
              <NavLink label="Jetzt ansehen" as="span" hasArrow={true} />
            </a>
          </>
        )}
      </Grid.Col>
    </Grid.Row>
  )
}

export const NavLink: React.FC<{
  label?: string | null
  url?: string | null
  id?: string | null
  hasArrow?: boolean
  className?: string
  as?: React.ElementType
}> = (props) => {
  const ElementType: React.ElementType = props.url ? 'a' : props.as || 'span'
  return (
    <ElementType
      className={cx('inline-block py-8', { 'mr-auto relative': props.hasArrow }, props.className)}
      style={{ paddingRight: '28px' }}
      href={appendNavParameter(props.url)}
      id={props.id}
    >
      <span className={cx({ 'inline-block border-b leading-24': props.hasArrow })}>{props.label}</span>
      {props.hasArrow && (
        <Icon id={EIconId.ARROW_RIGHT} className="absolute right-0 w-20 h-20 -translate-y-1/2" style={{ top: '50%' }} />
      )}
    </ElementType>
  )
}

export default NavigationBarFlyout
